export enum VIEW_MODES {
  GENERAL,
  BENEFITS,
  COMPANY_INFO,
}
